import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import type { TimeCondition } from 'modules/legal_entities/hooks/timeConditions/useGetTimeConditions'

export const DEFAULT_START_ON = 1
export const DEFAULT_DURATION = 12

interface TimeConditionFormData extends TimeCondition {
  legalEntityId: string
}

class TimeConditionsLegalEntityForm extends Form {
  constructor(values: TimeConditionFormData) {
    super(values, {
      id: 'string',
      startOn: 'number',
      duration: 'number',
      legalEntityId: 'string',
    })
    makeObservable(this, {
      isValid: computed,
    })
  }

  get isValid(): boolean {
    return this.get('startOn').value && this.get('legalEntityId').value
  }
}

export default TimeConditionsLegalEntityForm
